export default {"src":"/_next/static/media/chevrons-left.17a379e7.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};